import "./ProgressBar.scss";

function ProgressBar(props) {
  const progressBarAnimation = props.endingScreen
    ? "progress_bar__animation_none"
    : null;

  return (
    <div className="progress_bar">
      <img
        className="progress_bar__background"
        src="../assets/progressBar.png"
        alt="progressBar"
      ></img>
      <img
        className="progress_bar__2077"
        src="../assets/headerBar2077.png"
        alt="2077"
      ></img>
      <div className="progress_bar__segments">
        {props.questProgress.progressBar.map((item, index) => {
          return (
            <div
              key={index}
              className={`${
                item
                  ? "progress_bar__segment-blue"
                  : "progress_bar__segment-red"
              } ${progressBarAnimation}`}
              style={props.endingScreen === true ? { animation: "none" } : {}}
            />
          );
        })}
      </div>
    </div>
  );
}

export default ProgressBar;
